import supportedBrowsers from "supported_browsers"
import posthog from "posthog-js"

let errorPayload = {
  environment: window.gon?.railsEnv,
  release: window.gon?.release
}

function shouldTrackError(message) {
  const messageText = typeof message === "string" ? message.trim() : ""
  const ignoredMessages = [
    "Load failed",
    "A network error occurred.",
    "The user aborted a request.",
    "The operation was aborted."
  ]

  return (
    !window.gon?.disableRollbarJs &&
    supportedBrowsers.test(window.navigator.userAgent) &&
    window.location.hostname.endsWith(".kenhub.cn") &&
    !ignoredMessages.includes(messageText)
  )
}

function normalizeError(messageOrError, payloadError) {
  if (payloadError instanceof Error) return payloadError
  if (messageOrError instanceof Error) return messageOrError
  if (typeof payloadError === "string") return new Error(payloadError)
  if (typeof messageOrError === "string") return new Error(messageOrError)
  return new Error("Unknown JavaScript error")
}

function buildProperties(messageOrError, payload = {}) {
  const severity = payload.level || "error"
  const properties = {
    ...errorPayload,
    ...payload,
    severity,
    location: window.location.href
  }

  if (typeof messageOrError === "string") {
    properties.message = messageOrError
  }

  delete properties.level
  delete properties.error
  return properties
}

const errorTracker = {
  setErrorPayload: (payload) => {
    if (!payload || typeof payload !== "object") return
    errorPayload = {...errorPayload, ...payload}
  },

  getErrorPayload: () => errorPayload,

  sendErrorMsg: (messageOrError, payload = {}) => {
    if (!shouldTrackError(messageOrError)) return

    const error = normalizeError(messageOrError, payload.error)
    const properties = buildProperties(messageOrError, payload)

    if (typeof posthog.captureException === "function") {
      posthog.captureException(error, properties)
      return
    }

    posthog.capture("$exception", {
      ...properties,
      // eslint-disable-next-line camelcase
      $exception_message: error.message,
      // eslint-disable-next-line camelcase
      $exception_type: error.name
    })
  }
}

export default errorTracker